<div class="domain-input-control d-flex align-items-center">
  <div class="domain-input-wrapper d-flex align-items-center">
    <h4 class="mr-3 light">&#64;</h4>
    <input
      class="vitamui-input"
      [style.width.px]="280"
      type="text"
      size="10"
      [formControl]="control"
      [attr.placeholder]="placeholder"
      (blur)="onTouched()"
      (keydown.enter)="add()"
    />
    @if (control.pending) {
      <mat-spinner class="ml-2" [diameter]="spinnerDiameter"></mat-spinner>
    }
  </div>

  <div>
    <button type="button" class="btn primary ml-2" (click)="add()" [disabled]="buttonAddDisabled()">{{ 'COMMON.ADD' | translate }}</button>
  </div>
</div>

<div class="vitamui-input-errors">
  @if (control?.hasError('pattern')) {
    <div>{{ 'SHARED.DOMAIN_INPUT.WRONG_FORMAT' | translate }}</div>
  }
  @if (domainExists) {
    <div>{{ 'SHARED.DOMAIN_INPUT.DOMAIN_ALREADY_EXIST' | translate }}</div>
  }
  @if (!domainExists && control?.hasError('uniqueDomain')) {
    <div>{{ 'SHARED.DOMAIN_INPUT.DOMAIN_ALREADY_USED' | translate }}</div>
  }
</div>

<div class="vitamui-chip-list ml-4">
  @for (domain of domains; track domain) {
    <div class="vitamui-chip" (click)="setSelected(domain)" [class.active]="domain === selected">
      <div class="vitamui-chip-content">{{ domain }}</div>
      <div class="vitamui-remove-chip" (click)="remove(domain)">
        <i class="material-icons">clear</i>
      </div>
    </div>
  }
</div>
